import { useEffect, useRef, useState } from 'react'

import { createSafeResizeObserver } from '../../utils/safeResizeObserver'

const avgCharWidth = 8

export const textOverFlowSpace = ({
  description,
  customCharForRemoveFromMax,
}: {
  description: string
  customCharForRemoveFromMax: number
}) => {
  const [maxDescriptionWidth, setMaxDescriptionWidth] = useState<number>(0)
  const descriptionRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const resizeObserver = createSafeResizeObserver(() => {
      if (descriptionRef.current) {
        setMaxDescriptionWidth(descriptionRef.current.offsetWidth - 20)
      }
    })

    if (descriptionRef.current) {
      resizeObserver.observe(descriptionRef.current)
    }

    return () => {
      if (descriptionRef.current) {
        resizeObserver.unobserve(descriptionRef.current)
      }
      resizeObserver.disconnect()
    }
  }, [])

  const maxChars =
    Math.floor(maxDescriptionWidth / avgCharWidth) - customCharForRemoveFromMax

  const isTextLengthBig = description.length > maxChars

  const truncateDescription = (description: string) => {
    if (descriptionRef.current) {
      return isTextLengthBig
        ? description.substring(0, maxChars) + '...'
        : description
    }
    return description
  }

  return {
    maxDescriptionWidth,
    isTextLengthBig,
    truncateDescription,
    descriptionRef,
  }
}
